var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// Imports
import Vue from "vue";
import Component from "vue-class-component";
import { Clubs } from "../../../modules/clubs";
import { Utilities } from "../../../services/utilities";
// Define vue parameters
var EditClubsComponent = /** @class */ (function (_super) {
    __extends(EditClubsComponent, _super);
    /**
     * Setup the child and parent class
     */
    function EditClubsComponent() {
        var _this = _super.call(this) || this;
        // Create a clubs instance
        _this.clubs = new Clubs();
        return _this;
    }
    EditClubsComponent.prototype.logIt = function () {
        console.log(this.$data.currentClub.clubName);
    };
    /**
     * Component setup on mount
     */
    EditClubsComponent.prototype.mounted = function () {
        var _this = this;
        Utilities.toggleModalActiveClass(true);
        this.getClub().then(function (r) {
            _this.getClubTypes().then(function (rr) {
                _this.$data.loading = false;
            });
        });
    };
    EditClubsComponent.prototype.destroyed = function () {
        Utilities.toggleModalActiveClass(false);
    };
    /**
     * Get the types of clubs available
     */
    EditClubsComponent.prototype.getClubTypes = function () {
        var _this = this;
        return this.clubs.types().then(function (r) {
            _this.$data.clubTypes = r;
        });
    };
    /**
     * Get the current club
     */
    EditClubsComponent.prototype.getClub = function () {
        var _this = this;
        return this.clubs.getSpecific("me", this.$props.clubId).then(function (r) {
            _this.$data.currentClub = r;
        });
    };
    EditClubsComponent.prototype.deleteClub = function () {
        var _this = this;
        Utilities.confirm("Are you sure you want to delete this club?").then(function () {
            _this.clubs["delete"](_this.$props.clubId).then(function (r) {
                //alert("Your club has been deleted");
                _this.closeModal();
            });
            // @TODO - reload data without refreshing page
            window.location.href =
                "/players/me/clubs" + Utilities.getIframeParam();
        });
    };
    /**
     * Update the club
     */
    EditClubsComponent.prototype.updateClub = function () {
        // Reset errors
        this.$data.averageYardsError = null;
        this.$data.clubNameError = null;
        // Do error checking
        if (this.$refs.clubName.value === "") {
            this.$data.clubNameError = "Must not be empty";
            return false;
        }
        if (isNaN(this.$refs.averageYards.value) ||
            this.$refs.averageYards.value === "") {
            this.$data.averageYardsError = "Must be a number";
            return false;
        }
        this.clubs
            .update(this.$props.clubId, this.$refs.clubType.value, this.$refs.clubName.value, true, null, this.$refs.averageYards.value)
            .then(function (r) {
            //alert(`Your club has been updated.`);
            // @TODO - reload data without refreshing page
            window.location.href =
                "/players/me/clubs/" + Utilities.getIframeParam();
            /**
             * Reloading to club detail page after updating
             * results in data being shown that is not
             * current. Redirecting to club list page for now.
             * See above TODO for best solution.
             */
            //this.closeModal();
            //location.reload();
        });
    };
    EditClubsComponent.prototype.closeModal = function () {
        this.$modal.hide("edit-club");
    };
    EditClubsComponent = __decorate([
        Component({
            props: ["clubId"],
            data: function () {
                return {
                    currentClub: null,
                    selectedClub: null,
                    clubTypes: null,
                    loading: true,
                    averageYardsError: null,
                    clubNameError: null,
                    onError: false
                };
            }
        })
        // Define the component code
    ], EditClubsComponent);
    return EditClubsComponent;
}(Vue));
export default EditClubsComponent;
